<template>
    <div class="w-full h-[180px] md:h-[300px] relative">
      <div v-if="loading" class="w-full h-full bg-gray-200 animate-pulse"></div>
      <img
        class="w-full h-full object-cover"
        v-if="banner.imageUrl"
        :src="banner.imageUrl"
        alt="cover"
      />
      <!-- Overlay -->
      <div
        class="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-[#6f61177a]/80 to-[#6f61177a]/0 z-10"
      >
        <div
          class="flex flex-col absolute top-0 w-full h-full justify-center items-center z-20"
        >
          <div class="w-[94%] md:w-[75%] 2xl:w-[60%]">
            <div class="w-full md:w-[55%]">
              <h2 class="capitalize font-semibold text-xl md:text-4xl text-white">
                {{ banner.name }}
              </h2>
              <p class="text-white pt-3" v-if="banner.description">
                {{ banner.description }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "BannerSection",
    props: {
      banner: {
        type: Object,
        required: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
  };
  </script>
  